module.exports = __webpack_public_path__ + "static/media/rivermeadow.0bc5bb0c.svg";